import { Button } from 'components/base';
import { FiChevronRight } from 'react-icons/fi';
import HeroImg from 'assets/images/hero.png';
import useTranslation from 'hooks/useTranslation';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const translation = useTranslation();
  const navigate = useNavigate();

  const toOrder = () => {
    navigate('/order');
  };

  const WhatsAppLink = () => {
    const phoneNumber = '+41796970821';
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl);
  };

  return (
    <div className="flex flex-col bg-background-light-blue px-4 py-[50px] lg:flex-row lg:items-center lg:justify-between lg:px-[147px] lg:pt-[200px] lg:pb-[120px] ">
      <div className="mt-[60px] flex flex-col lg:mt-0 lg:max-w-[535px]">
        <p className="text-[32px] font-extrabold tracking-wide text-primary-blue lg:text-[52px]">
          {translation.takeYourBusiness}{' '}
          <span className="text-primary-light-blue">
            {translation.theNextLevel}
          </span>
        </p>
        <p className="mt-3 text-sm leading-6 text-primary-grey lg:text-base">
          {translation.getStartedIn} <br className="block lg:hidden" />
          {translation.qualityWebsite} {translation.justWeek}
        </p>

        <div className="flex flex-col lg:mt-[60px] lg:flex-row">
        <Button
            onClick={WhatsAppLink}
            theme="PRIMARY"
            className="mt-4 flex items-center self-center lg:mt-0 lg:ml-4"
          >
            <p>{translation.getFreeConsult}</p>
            <FiChevronRight className="ml-4 h-5 w-5" />
          </Button>
          {/*<Button
            onClick={toOrder}
            theme="PRIMARY"
            className="mt-8 w-full lg:mt-0 lg:w-auto lg:py-[14px]"
          >
            <p>{translation.getStarted}</p>
            </Button>*/}

          
        </div>
      </div>

      <div className="mt-[60px] lg:mt-0">
        <img alt="" src={HeroImg} className="w-full lg:w-[534px]" />
      </div>
    </div>
  );
};

export default Header;
